// global __webpack_public_path__:writable
// global __PUBLIC_PATH__:readable
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line @typescript-eslint/no-unused-vars
// eslint-disable-next-line camelcase
// eslint-disable-next-line no-undef
__webpack_public_path__ = __PUBLIC_PATH__;
